import { ReactNode } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelopeOpenText } from '@fortawesome/free-solid-svg-icons'
import { speakToKitThemeVars } from '../theme/speakToKitThemeVars'

type CandidateMagicLinkNotificationProps = {
    email: string
    title?: string
    subtitle?: string
    details?: ReactNode
    note?: string
    onUseDifferentEmail?: () => void
}

export default function CandidateMagicLinkNotification({
    email,
    title = 'Check your email!',
    subtitle,
    details,
    note = 'If you do not see it in a few minutes, check your spam folder or try again.',
    onUseDifferentEmail,
}: CandidateMagicLinkNotificationProps): React.JSX.Element {
    const fallbackSubtitle = `We sent a magic link to ${email}. Use it to continue.`

    return (
        <div
            className="min-h-screen bg-background text-foreground font-sans antialiased flex items-center justify-center px-4 py-10"
            style={speakToKitThemeVars}
        >
            <div className="w-full max-w-md rounded-3xl border border-border bg-card p-8 text-center shadow-[var(--shadow-card)] space-y-6">
                <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary">
                    <FontAwesomeIcon
                        icon={faEnvelopeOpenText}
                        className="text-3xl"
                    />
                </div>
                <div className="space-y-3">
                    <h1 className="text-2xl font-semibold text-foreground">
                        {title}
                    </h1>
                    <p className="text-sm text-muted-foreground whitespace-pre-line">
                        {subtitle || fallbackSubtitle}
                    </p>
                    {details ? (
                        <div className="text-sm text-muted-foreground space-y-2">
                            {details}
                        </div>
                    ) : null}
                    {note && (
                        <p className="text-xs text-muted-foreground/80">
                            {note}
                        </p>
                    )}
                </div>
                {onUseDifferentEmail && (
                    <button
                        type="button"
                        className="text-sm font-semibold text-primary hover:text-primary/80"
                        onClick={onUseDifferentEmail}
                    >
                        Use a different email
                    </button>
                )}
            </div>
        </div>
    )
}
